var _path, _g, _rect, _rect2, _rect3, _rect4, _rect5, _g2, _path2, _rect6, _path3, _g3, _path4, _path5, _path6, _circle, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchnotfound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 159,
    viewBox: "0 0 176 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.9346 137.502C119.905 137.502 150.686 106.721 150.686 68.751C150.686 30.7809 119.905 0 81.9346 0C43.9645 0 13.1836 30.7809 13.1836 68.751C13.1836 106.721 43.9645 137.502 81.9346 137.502Z",
    fill: "url(#paint0_linear_1701_3505)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1701_3505)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.9727,
    y: 19.6602,
    width: 71.3504,
    height: 88.82,
    rx: 16,
    fill: "url(#paint1_linear_1701_3505)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.2734,
    y: 31.0391,
    width: 50,
    height: 1,
    rx: 0.5,
    fill: "#FF8F6B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.2734,
    y: 50.0391,
    width: 57.2926,
    height: 1,
    rx: 0.5,
    fill: "#D5D5D5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 53.2734,
    y: 69.0391,
    width: 57.2926,
    height: 1,
    rx: 0.5,
    fill: "#D5D5D5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 53.2734,
    y: 88.0391,
    width: 57.2926,
    height: 1,
    rx: 0.5,
    fill: "#D5D5D5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 53.2734,
    y: 107.039,
    width: 57.2926,
    height: 1,
    rx: 0.5,
    fill: "#D5D5D5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1701_3505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.095 9.9375H126.674C125.07 9.9375 123.77 11.3059 123.77 12.994V30.0208C123.77 31.7089 125.07 33.0773 126.674 33.0773H161.095C162.699 33.0773 164 31.7089 164 30.0208V12.994C164 11.3059 162.699 9.9375 161.095 9.9375Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.375 25.1095C134.274 25.1095 135.813 23.5704 135.813 21.6719C135.813 19.7734 134.274 18.2344 132.375 18.2344C130.477 18.2344 128.938 19.7734 128.938 21.6719C128.938 23.5704 130.477 25.1095 132.375 25.1095Z",
    fill: "#FFDA45"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 140.395,
    y: 18.2344,
    width: 18.3336,
    height: 6.8751,
    rx: 3.43755,
    fill: "#D5D5D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.015 112.553C109.415 112.553 116.291 110.308 121.999 106.462L145.278 128.684L153.734 118.872L131.257 97.416C135.392 91.5768 137.823 84.4448 137.823 76.7453C137.823 56.9692 121.791 40.9375 102.015 40.9375C82.2387 40.9375 66.207 56.9692 66.207 76.7453C66.207 96.5214 82.2387 112.553 102.015 112.553ZM132.568 76.7724C132.568 93.5151 118.996 107.088 102.253 107.088C85.5102 107.088 71.9375 93.5151 71.9375 76.7724C71.9375 60.0297 85.5102 46.457 102.253 46.457C118.996 46.457 132.568 60.0297 132.568 76.7724Z",
    fill: "#F26519"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_1701_3505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.252 107.767C119.497 107.767 133.476 93.9152 133.476 76.8286C133.476 59.742 119.497 45.8906 102.252 45.8906C85.007 45.8906 71.0273 59.742 71.0273 76.8286C71.0273 93.9152 85.007 107.767 102.252 107.767Z",
    fill: "white",
    fillOpacity: 0.3
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.653 76.7099L115.209 69.1828C115.917 68.4382 116.305 67.4485 116.29 66.4242C116.276 65.3998 115.86 64.4215 115.131 63.6971C114.402 62.9727 113.418 62.5593 112.387 62.5448C111.357 62.5303 110.361 62.9158 109.612 63.6194L102.039 71.1464L94.4823 63.6194C94.1187 63.2369 93.6816 62.9308 93.1969 62.7191C92.7121 62.5075 92.1897 62.3946 91.6603 62.3871C91.1309 62.3797 90.6054 62.4778 90.1148 62.6757C89.6243 62.8736 89.1787 63.1673 88.8043 63.5394C88.4299 63.9115 88.1344 64.3544 87.9353 64.842C87.7362 65.3295 87.6374 65.8519 87.6449 66.378C87.6524 66.9042 87.766 67.4235 87.979 67.9052C88.1919 68.387 88.4999 68.8214 88.8847 69.1828L96.4537 76.7099L88.8847 84.2369C88.4999 84.5983 88.1919 85.0327 87.979 85.5145C87.766 85.9963 87.6524 86.5156 87.6449 87.0417C87.6374 87.5679 87.7362 88.0902 87.9353 88.5777C88.1344 89.0653 88.4299 89.5082 88.8043 89.8803C89.1787 90.2524 89.6243 90.5461 90.1148 90.744C90.6054 90.9419 91.1309 91.0401 91.6603 91.0326C92.1897 91.0252 92.7121 90.9123 93.1969 90.7006C93.6816 90.489 94.1187 90.1828 94.4823 89.8004L102.055 82.2733L109.629 89.8004C110.385 90.4625 111.367 90.813 112.374 90.7806C113.381 90.7481 114.338 90.3351 115.05 89.6257C115.762 88.9163 116.174 87.964 116.204 86.9627C116.233 85.9614 115.878 84.9866 115.209 84.2369L107.653 76.7099Z",
    fill: "#8E8E8E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.281 128.758L153.738 118.946L155.011 120.162C156.247 121.342 156.987 122.99 157.068 124.744C157.15 126.498 156.566 128.214 155.445 129.514C154.324 130.815 152.758 131.593 151.091 131.679C149.425 131.764 147.794 131.15 146.558 129.97L145.284 128.754L145.281 128.758Z",
    fill: "#FA9025"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2535 35.5743C28.2427 34.7573 28.1402 33.9332 27.9352 33.1035C27.2164 30.1919 24.0092 28.3226 20.5957 27.8831C17.1836 27.4436 13.6352 28.4438 12.2677 30.9765C11.4854 32.4246 11.3775 33.6726 11.6972 34.7249C12.0155 35.7715 12.7707 36.6392 13.7957 37.3154C16.6535 39.1987 21.6585 39.5833 23.9418 38.7958C24.9978 38.431 26.0295 37.9915 27.0343 37.4886C26.4597 40.7806 24.3194 43.8993 21.4629 46.7096C15.2549 52.8174 5.62136 57.4532 0.375015 59.1577C0.093142 59.2492 -0.0633175 59.562 0.0243463 59.8564C0.11201 60.1508 0.411411 60.3156 0.693284 60.224C6.04348 58.4858 15.8646 53.7514 22.1952 47.5224C25.4658 44.305 27.7963 40.6834 28.1941 36.8759C35.5876 32.75 41.6593 25.2645 46.8504 18.9651C47.0432 18.7326 47.0176 18.3791 46.7937 18.1776C46.5699 17.9776 46.2327 18.0029 46.0398 18.2368C41.0605 24.2784 35.2814 31.4653 28.2535 35.5743ZM27.1786 36.173C27.2191 35.2545 27.1327 34.322 26.8994 33.381C26.2777 30.861 23.4198 29.3707 20.4649 28.9903C18.6536 28.7579 16.7911 28.9495 15.3305 29.6313C14.412 30.0595 13.6554 30.6807 13.1995 31.5259C12.6007 32.6345 12.4713 33.5825 12.7167 34.3868C12.9622 35.1968 13.5718 35.8476 14.3662 36.3702C16.9705 38.0873 21.5276 38.4522 23.6059 37.7352C24.8319 37.3126 26.0215 36.7857 27.1786 36.173Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 159.27,
    cy: 88.6758,
    r: 3.43755,
    fill: "#FF8F6B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4531 112.459C30.0665 112.229 30.7121 111.923 31.2099 111.481C31.8012 110.955 32.0416 110.278 32.2031 109.565C32.4104 108.649 32.4933 107.674 32.7447 106.756C32.8377 106.416 33.0169 106.287 33.0937 106.23C33.288 106.086 33.4843 106.047 33.6691 106.061C33.888 106.078 34.1888 106.165 34.3866 106.552C34.4148 106.607 34.4514 106.691 34.4761 106.806C34.4941 106.891 34.5057 107.156 34.5248 107.265C34.5724 107.533 34.6122 107.802 34.6496 108.072C34.774 108.971 34.8456 109.735 35.2387 110.561C35.7722 111.682 36.3067 112.368 37.0316 112.672C37.7325 112.966 38.5705 112.911 39.6413 112.68C39.7432 112.654 39.844 112.632 39.9438 112.614C40.4159 112.527 40.8672 112.853 40.9599 113.348C41.0526 113.843 40.7526 114.325 40.2847 114.433C40.1871 114.456 40.0908 114.477 39.9956 114.497C38.5487 114.874 36.8736 116.22 35.9002 117.398C35.6001 117.761 35.1608 118.776 34.7127 119.424C34.382 119.902 34.0104 120.217 33.6984 120.328C33.4893 120.403 33.313 120.392 33.1674 120.354C32.9559 120.299 32.7803 120.179 32.6456 119.987C32.5723 119.882 32.5042 119.741 32.4718 119.562C32.4563 119.475 32.4545 119.255 32.4549 119.156C32.3635 118.825 32.2518 118.503 32.1703 118.169C31.9761 117.373 31.5949 116.869 31.1422 116.204C30.7188 115.581 30.264 115.189 29.5973 114.877C29.5106 114.854 28.8107 114.674 28.5636 114.571C28.2025 114.419 28.0305 114.165 27.9681 114.028C27.8619 113.795 27.851 113.593 27.8722 113.423C27.9035 113.174 28.01 112.96 28.199 112.787C28.3161 112.68 28.4909 112.576 28.725 112.525C28.9059 112.485 29.3857 112.462 29.4531 112.459ZM33.5587 111.162C33.5912 111.238 33.6257 111.314 33.6624 111.391C34.4437 113.034 35.3174 113.951 36.3793 114.395L36.4149 114.41C35.7045 114.965 35.0614 115.585 34.5699 116.18C34.3675 116.425 34.0996 116.934 33.8101 117.455C33.5471 116.556 33.117 115.92 32.5761 115.124C32.1629 114.516 31.73 114.059 31.1979 113.687C31.6108 113.464 32.0046 113.203 32.3477 112.898C32.9188 112.39 33.2964 111.801 33.5587 111.162Z",
    fill: "#FF8F6B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1701_3505",
    x: 16.9727,
    y: 9.66016,
    width: 131.351,
    height: 148.82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1701_3505"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1701_3505",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1701_3505",
    x: 116.77,
    y: 0.9375,
    width: 66.2305,
    height: 49.1396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1701_3505"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1701_3505",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_1701_3505",
    x: 63.0273,
    y: 37.8906,
    width: 78.4492,
    height: 77.876,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1701_3505"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1701_3505",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1701_3505",
    x1: 81.4046,
    y1: -22.387,
    x2: 82.813,
    y2: 219.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C8AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1701_3505",
    x1: 82.6479,
    y1: 19.6602,
    x2: 82.6479,
    y2: 108.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FAFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchnotfound);
export default __webpack_public_path__ + "static/media/searchnotfound.ef06cae3c1a00f2c7fb7067d8d093b39.svg";
export { ForwardRef as ReactComponent };